module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Incoterms Code","couldNotFindIncoterm":"Could not find incoterm"},"no":{"title":"Incoterms Kode","couldNotFindIncoterm":"Fant ikke incoterm"}}')
  delete Component.options._Ctor
}
